import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { Flex, Text, Hide, Box } from 'roo-ui/components';
import { getCampaignTitle, getCampaignMessage } from 'store/campaign/campaignSelectors';
import CampaignMessageLink from './CampaignMessageLink';

const BannerText = styled(Text)`
  text-transform: uppercase;
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: 14px;
  text-align: center;
`;

const BannerHide = styled(Hide)`
  display: flex;
`;

const CampaignMessaging = ({ showDefaultMessage, ...rest }) => {
  // const DEFAULT_TITLE = 'Use a mix of cash and Qantas Points to book';
  // const DEFAULT_MESSAGE = `you'll still earn 3 points per $1 value^`;

  const DEFAULT_TITLE = 'Enjoy more Classic Hotel Rewards';
  const DEFAULT_MESSAGE = `when you use points.`;

  const title = useSelector(getCampaignTitle);
  const message = useSelector(getCampaignMessage);
  const hasCampaign = !!title;

  const titleToDisplay = hasCampaign ? title : DEFAULT_TITLE;
  const messageToDisplay = hasCampaign ? message : DEFAULT_MESSAGE;
  const showCampaignBanner = hasCampaign || showDefaultMessage;

  if (!showCampaignBanner) return null;

  return (
    <Box {...rest} data-testid="campaign-banner-wrapper">
      <Flex bg="blue" justifyContent="center" alignItems="center" p={3}>
        <CampaignMessageLink title={titleToDisplay}>
          <BannerText data-testid="title">{titleToDisplay}</BannerText>
          {!isEmpty(messageToDisplay) && (
            <BannerHide xs>
              <BannerText mx="1">-</BannerText>
              <BannerText data-testid="message">{messageToDisplay}</BannerText>
            </BannerHide>
          )}
        </CampaignMessageLink>
      </Flex>
    </Box>
  );
};

CampaignMessaging.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  showDefaultMessage: PropTypes.bool,
};

CampaignMessaging.defaultProps = {
  title: null,
  message: null,
  showDefaultMessage: true,
};

export default CampaignMessaging;
